import React, { Fragment, useState, useCallback } from 'react'
import PropTypes from 'prop-types'

import InformationalModal from '@scoir/components-core/dist/components/InformationalModal'

import createSupportTicket from 'components/SupportTicketCreator/create-support-ticket'

const SupportTicketLink = ({ ticketConfig, modalTitle, modalBody, children }) => {
  const [open, setOpen] = useState(false)
  const onClose = () => setOpen(!open)

  const createTicket = useCallback(
    (e) => {
      e.preventDefault()
      createSupportTicket(ticketConfig).then(() => setOpen(true))
    },
    [ticketConfig],
  )

  return (
    <Fragment>
      <a
        href="#"
        onClick={createTicket}
      >
        {children}
      </a>
      <InformationalModal
        className="support-ticket-created-status-comp"
        theme="seamless"
        show={open}
        onHide={onClose}
      >
        <InformationalModal.Header>
          <InformationalModal.Title>{modalTitle}</InformationalModal.Title>
        </InformationalModal.Header>
        <InformationalModal.Body>{modalBody}</InformationalModal.Body>
      </InformationalModal>
    </Fragment>
  )
}
SupportTicketLink.propTypes = {
  ticketConfig: PropTypes.object.isRequired,
  modalTitle: PropTypes.any.isRequired,
  modalBody: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
}

export default SupportTicketLink
